import { useAuth } from '@/hooks/use-auth';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function PrivateRoute({ children }: React.PropsWithChildren): JSX.Element {
  const { isInitialized, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(
    () => {
      if (!isInitialized) {
        return;
      }

      if (!isAuthenticated) {
        navigate('/login', {
          state: { returnUrl: location.pathname + location.search }
        });
        return;
      }

      if (user && !user.mobileNumberCountryCode && !user.mobileNumber && !user.impersonated) {
        navigate('/two-factor-authentication');
        return;
      }

      setChecked(true);
    },
    // eslint-disable-next-line
    [isInitialized, isAuthenticated]
  );

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // authenticated / authorized.

  return children as JSX.Element;
}
